import React from "react";
import { MenuItem, Tooltip, Typography } from "@mui/material";
import {
  StyledTextField,
  StyledSelectField,
  StyledInputRow,
  styles,
  RequiredField,
  StyledDateTimePicker
} from "./CustomInputStyles";
import HelpIcon from "@mui/icons-material/Help";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export const CustomTextField = ({
  id,
  fieldName,
  placeholder,
  value,
  onChange,
  disabled,
  isRequired,
  toolTipTitle,
}) => {
  return (
    <StyledInputRow>
      <Typography noWrap sx={styles.InputLabel}>
        {fieldName}
        {isRequired ? <RequiredField>*</RequiredField> : <></>}
        {toolTipTitle ? (
          <Tooltip placement="top" title={toolTipTitle}>
            <HelpIcon sx={styles.Icon} />
          </Tooltip>
        ) : (
          <></>
        )}
      </Typography>
      <StyledTextField
        required
        id={id}
        variant="outlined"
        size="small"
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </StyledInputRow>
  );
};

export const CustomDropDown = ({
  id,
  fieldName,
  placeholder,
  value,
  onChange,
  disabled,
  isRequired,
  toolTipTitle,
  menuItems,
}) => {
  return (
    <>
      <StyledInputRow>
        <Typography sx={styles.InputLabel}>
          {fieldName}
          {isRequired ? <RequiredField>*</RequiredField> : <></>}
          {toolTipTitle ? (
            <Tooltip placement="top" title={toolTipTitle}>
              <HelpIcon sx={styles.Icon} />
            </Tooltip>
          ) : (
            <></>
          )}
        </Typography>
        <StyledSelectField
          required
          id={id}
          variant="outlined"
          size="small"
          fullWidth
          value={value}
          disabled={disabled}
          onChange={onChange}
        >
          {Object.keys(menuItems).map((key) => (
            <MenuItem key={key} value={menuItems[key]}>
              {key}
            </MenuItem>
          ))}
        </StyledSelectField>
      </StyledInputRow>
    </>
  );
};

export const CustomDateTimePicker = ({
  id,
  fieldName,
  placeholder,
  value,
  onChange,
  disabled,
  isRequired,
  toolTipTitle,
}) => {
  return (
    <StyledInputRow>
      <Typography noWrap sx={styles.InputLabel}>
        {fieldName}
        {isRequired ? <RequiredField>*</RequiredField> : <></>}
        {toolTipTitle ? (
          <Tooltip placement="top" title={toolTipTitle}>
            <HelpIcon sx={styles.Icon} />
          </Tooltip>
        ) : (
          <></>
        )}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
      <StyledDateTimePicker
        required
        id={id}
        variant="outlined"
        size="small"
        fullWidth
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      </LocalizationProvider>
    </StyledInputRow>
  );
};
